import * as types from './actionTypes.projectAnalytics';

export const getAnalyticsReports = ({ project, environment, resolve, reject }) => ({
    type: types.GET_ANALYTICS_REPORTS_REQ,
    project,
    environment,
    resolve,
    reject
});

export const getDataByReport = ({ projectId, environment, report, resolve, reject }) => ({
    type: types.GET_DATA_BY_REPORT_REQ,
    projectId,
    environment,
    report,
    resolve,
    reject
});

export const updateReportDataByDialogs = ({ projectId, filters, environment, report, dialogIds, resolve, reject }) => ({
    type: types.UPDATE_PATTERNS_IN_ANALYTICS_REPORT_REQ,
    projectId,
    report,
    dialogIds,
    filters,
    environment,
    resolve,
    reject
});

export const updateIntentsInDataReport = ({ projectId, environment, report, dialogIds, filters, resolve, reject }) => ({
    type: types.UPDATE_INTENTS_IN_ANALYTICS_REPORT_REQ,
    projectId,
    report,
    dialogIds,
    environment,
    filters,
    resolve,
    reject
});

export const addAnalyticsReport = ({ project, environment, report, resolve, reject }) => ({
    type: types.ADD_ANALYTICS_REPORT_REQ,
    project,
    environment,
    report,
    resolve,
    reject
});

export const renameAnalyticsReport = ({ project, reportName, newReportName, resolve, reject }) => ({
    type: types.RENAME_ANALYTICS_REPORT_REQ,
    project,
    reportName,
    newReportName,
    resolve,
    reject
});

export const deleteAnalyticsReport = ({ project, reportName, resolve, reject }) => ({
    type: types.DELETE_ANALYTICS_REPORT_REQ,
    project,
    reportName,
    resolve,
    reject
});

export const addAnalyticsReportFilter = ({ projectId, reportName, filters, filterIndex, resolve, reject }) => ({
    type: types.ADD_ANALYTICS_REPORT_FILTER_REQ,
    projectId,
    reportName,
    filters,
    filterIndex,
    resolve,
    reject
});


export const deleteAnalyticsReportFilter = ({ projectId, reportName, filterIndex, resolve, reject }) => ({
    type: types.DELETE_ANALYTICS_REPORT_FILTER_REQ,
    projectId,
    reportName,
    filterIndex,
    resolve,
    reject
});

export const changeAnalyticsPeriodReportFilter = ({ projectId, environment, reportName, period, startTs, endTs, resolve, reject }) => ({
    type: types.CHANGE_ANALYTICS_PERIOD_REPORT_FILTER_REQ,
    projectId,
    environment,
    reportName,
    period,
    startTs,
    endTs,
    resolve,
    reject
});

export const changeAnalyticsDateRangeReportFilter = ({ projectId, environment, reportName, startTs, endTs, resolve, reject }) => ({
    type: types.CHANGE_ANALYTICS_DATE_RANGE_REPORT_FILTER_REQ,
    projectId,
    environment,
    reportName,
    startTs,
    endTs,
    resolve,
    reject
});

export const toggleShowEventsFilterForPatternFlow = ({ projectId, environment, reportName, onlyPatternOnPatternFlow, dialogIds, resolve, reject }) => ({
    type: types.TOGGLE_SHOW_EVENTS_FILTER_FOR_PATTERN_FLOW_REQ,
    projectId,
    environment,
    reportName,
    onlyPatternOnPatternFlow,
    dialogIds,
    resolve,
    reject
});

export const resetAnalyticsReportsData = ({ projectId, resolve, reject }) => ({
    type: types.RESET_ANALYTICS_REPORTS_DATA_REQ,
    projectId,
    resolve,
    reject
});

export const toggleReportSection = ({ project, report, sectionName, collapsed, resolve, reject }) => ({
    type: types.TOGGLE_REPORT_SECTION_REQ,
    project,
    report,
    sectionName,
    collapsed,
    resolve,
    reject
});
